document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector(".kg-out-wrap-intro-four-v2");
    if (!section) return;

    const rotateButtons = section.querySelectorAll(".rotate-four-v2");

    gsap.from(section.querySelectorAll(".kg-heading-h3-above-v2, .kg-heading-h2-v2, .kg-heading-h3-v2"), {
        opacity: 0,
        y: 50,
        stagger: 0.2,
        duration: 1,
        ease: "power2.out",
    });

    gsap.from(rotateButtons, {
        opacity: 0,
        x: -100,
        stagger: 0.2,
        duration: 1,
        ease: "power2.out",
        delay: 0.5,
    });

    gsap.from(section.querySelectorAll(".kg-woods-h2-four-v2, .kg-woods-h3-four-v2"), {
        opacity: 0,
        y: 30,
        stagger: 0.2,
        duration: 1,
        ease: "power2.out",
        delay: 1,
    });
});

window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
        const eventInit = new Event("DOMContentLoaded", { bubbles: true });
        document.dispatchEvent(eventInit);
    }
});
